import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPersonalSalaryAvailableColumns, getMrp, getRealEstateClassListAll } from './api';

export const path = '/calculator-tariff/personal-salary/list';

const PagePersonalSalaryList: React.FC = (props) => {
  const PersonalSalaryList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPersonalSalaryAvailableColumns,
      realEstateClasses: getRealEstateClassListAll,
      mrp: getMrp,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PersonalSalaryList {...props} />;
};

export default PagePersonalSalaryList;
